import { useContext, useEffect, useMemo, useState } from 'react';
import "./layout.less"
import LayoutBackground from './LayoutBackground';
import { useSelector } from 'react-redux';
import { layoutSelector } from 'state/layoutSlice';
import useLayout from './useLayout';
import useSimpleBreakpoint from 'services/hooks/useSimpleBreakpoint';
import { LayoutConfig, LayoutProps } from './Layout.types';

export const defaultLayout: LayoutConfig = {
  navbar: "visible",
  siderVisible: false,
  isSidebarExpanded: false,
  isSiderMobile: false,
  background: "solid",
  contentWrapperClass: "panel",
  isMobileSiderShowing: false,
  siderMenuGrouping: "modules",
  darkMode: false,
  reason: "default"
}

// type Layout = {
//   layout: LayoutConfig;
//   toggleNavbar: () => void;
//   toggleSider: () => void;
//   toggleSidebarExpanded: () => void;
//   toggleMobileSider: () => void;
//   toggleBackground: () => void;
//   setLayout: (layout: Partial<LayoutConfig>) => void;
// }

const MID = 992;
const SM = 576;

export const LayoutPresets: { [key: string]: Partial<LayoutConfig> } = {
  "panel": {
    navbar: "visible",
    siderVisible: true,
    isSidebarExpanded: true,
    background: "dark",
    contentWrapperClass: "panel",
  },
  "panel-with-scroll": {
    navbar: "visible",
    siderVisible: true,
    isSidebarExpanded: true,
    background: "dark",
    contentWrapperClass: "panel-with-scroll",
  },
  "panel-solid": {
    navbar: "visible",
    siderVisible: true,
    isSidebarExpanded: true,
    background: "solid",
    contentWrapperClass: "clear",
  },
  "clear": {
    navbar: "visible",
    siderVisible: true,
    isSidebarExpanded: true,
    background: "dark",
    contentWrapperClass: "clear",
  },
  "clear-with-scroll": {
    navbar: "visible",
    siderVisible: true,
    isSidebarExpanded: true,
    background: "dark",
    contentWrapperClass: "clear-with-scroll",
  },
  "onboarding": {
    navbar: "floating",
    siderVisible: false,
    isSidebarExpanded: false,
    background: "solid",
    contentWrapperClass: "two-columns",
  },
  "loading": {
    navbar: "hidden",
    siderVisible: false,
    isSidebarExpanded: false,
    background: "solid",
    contentWrapperClass: "",
  }
}

export type LayoutPresetNames = keyof typeof LayoutPresets;

const LayoutProvider = ({ children }: LayoutProps) => {

  const layout = useSelector(layoutSelector);
  const { setLayout } = useLayout();
  const [, , _isMobile] = useSimpleBreakpoint();
  const isMobile = window.innerWidth < 768 || _isMobile;
  
  useEffect(() => {

    if (isMobile) {
      setLayout({ isSiderMobile: true, isSidebarExpanded: false, reason: "LayoutEffect-isMobile" });
    } else {
      setLayout({
        isSiderMobile: false,
        isMobileSiderShowing: false,
        isSidebarExpanded: true,
        reason: "LayoutEffect-isNotMobile"
      });
    }

  }, [isMobile]);


  return (
    <div className={`layout ${layout.darkMode ? "dark-mode" : "light-mode"}`}>
      <div className="layout-top-banner" id="layout-top-banner"></div>
      <aside
        className={`sider 
            ${layout.isSidebarExpanded ? "expanded" : "collapsed"} 
            ${layout.isSiderMobile ? "mobile" : "desktop"} 
            ${layout.isMobileSiderShowing ? "mobile-visible" : "mobile-hidden"} 
            ${layout.siderVisible ? "visible" : ""}
            `}
        id="layout-sider"
      ></aside>
      <div className={`main-column navBar-${layout.navbar}`}>
        <header className={`navBar`} id="layout-navbar"></header>
        <div
          className={`content-wrapper ${
            layout.contentWrapperClass ? layout.contentWrapperClass : ""
          } ${layout.isSiderMobile ? "mobile" : ""}`}
        >
          <main className="layout-content" id="layout-content"></main>
          <aside className="content-sidebar" id="layout-sidebar"></aside>
          <div className="content-overlay" id="layout-content-overlay"></div>
        </div>
      </div>
      <div className="layout-bottom-banner" id="layout-bottom-banner"></div>
      <LayoutBackground />
    </div>
  );


}

export default LayoutProvider;

